import { createFileRoute, redirect } from '@tanstack/react-router';
import { START_PAGE } from 'config/app';

// Redirect bare / to the default page
export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    throw redirect({ to: START_PAGE as string, replace: true });
  },
});
